<div class="ts-card">
    <div class="page-header">
        <h2 class="ts-card-title page-title">Account Details</h2>
        <button class="btn-primary" type="button" (click)="refreshData()">
            <fa-icon [icon]="faRotate"></fa-icon>
            Refresh
        </button>
    </div>
    <app-loading *ngIf="loading"></app-loading>

    <ng-container *ngIf="!loading">
        <form  class="detail-container-form">
        <div class="account-form-layout">
            <div class="account-select-row">
                <div class="ts-form-field">
                    <label class="ts-label">DVP Accounts</label>
                    <select class="ts-select" [(ngModel)]="selectedDvpAccount" [ngModelOptions]="{standalone: true}" (change)="onChange($event)" [compareWith]="compareAccounts">
                        <option *ngFor="let account of allElements" [ngValue]="account">{{account.accountId}}</option>
                    </select>
                </div>
            </div>
            <div class="account-details-grid" *ngFor="let accountDetail of accountDetails">
                <div class="detail-label">
                    <b>{{accountDetail.description}}</b>
                </div>
                <div class="detail-value">
                    <span class="numeric-value">{{ accountDetail.value | currency:'USD':'symbol':'1.2-2' }}</span>
                </div>
            </div>
            <div class="account-footnote">
                <p>* Values are Real-time as of last account transaction</p>
            </div>
        </div>
    </form>
    <div class="ts-tabs">
        <div class="ts-tab-header">
            <button class="ts-tab-button" [class.active]="activeTab === 0" (click)="activeTab = 0">Positions</button>
            <button class="ts-tab-button" [class.active]="activeTab === 1" (click)="activeTab = 1">All Accounts</button>
        </div>
        <div class="ts-tab-content">
            <div [hidden]="activeTab !== 0">
                <app-account-positions></app-account-positions>
            </div>
            <div [hidden]="activeTab !== 1">
                <app-all-accounts></app-all-accounts>
            </div>
        </div>
    </div>
    </ng-container>
</div>
